export const styles = {
    progress: {
      left: '50%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%,-50%)'
    }
};